import { render, staticRenderFns } from "./auth-container.vue?vue&type=template&id=709648f7&lang=pug"
import script from "./auth-container.js?vue&type=script&lang=js&external"
export * from "./auth-container.js?vue&type=script&lang=js&external"
import style0 from "./auth-container.vue?vue&type=style&index=0&id=709648f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports